import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doOpenModal } from '../store/actions/modal';
import { ModalType } from '../Modal/ModalTypes';

import formStyles from './Form.module.scss'
import { selectTrainingVideos } from '../store/selectors';
import { doGetTrainingVideos } from '../store/actions/trainingVideos';

function FormHelp() {
  const dispatch = useDispatch();
  const trainingVideos = useSelector(selectTrainingVideos);

  const openModalUrl = (e: React.MouseEvent, url: string, title: string) => {
    dispatch(doOpenModal({type: ModalType.Url, url, title}))
    e.preventDefault();
  }

  const openModalVideo = (e: React.MouseEvent, vimeoId: number, title: string) => {
    dispatch(doOpenModal({type: ModalType.Vimeo, vimeoId, title}))
    e.preventDefault();
  }

  useEffect(() => {
    dispatch(doGetTrainingVideos());
  }, [dispatch])

  const trainingRender = trainingVideos.map((video) => {
    return <label key={video.id}><button className={formStyles.labelButton} onClick={e => openModalVideo(e, video.vimeoId, video.title)}>{ video.title }</button></label>;
  })

  return (
    <div className={formStyles.formsWrapper}>
      <form className={formStyles.settingsForm}>
      <fieldset>
          <legend>Help</legend>
          <label><button className={formStyles.labelButton} onClick={e => openModalUrl(e, "https://content.clusterx.com/static/help.html", "Help")}>Help</button></label>
        </fieldset>

        <fieldset>
          <legend>Explainer Videos</legend>
          { trainingRender }
        </fieldset>

        <fieldset>
          <legend>Support</legend>
          <label><a className={formStyles.labelLink} href={encodeURI("mailto:support@clusterx.com?&subject=Cluster support request&body=I need help with:\r\n")}>Email support@clusterx.com</a></label>
          <label><a className={formStyles.labelLink} href="tel:18009239128">Phone 1-800-923-9128</a></label>
        </fieldset>
      </form>
    </div>
  );
}

export default FormHelp;

